__turbopack_context__.v({
  "button-group": "DynamicTariff-module-scss-module__R9aHHq__button-group",
  "info": "DynamicTariff-module-scss-module__R9aHHq__info",
  "portal": "DynamicTariff-module-scss-module__R9aHHq__portal",
  "quiz": "DynamicTariff-module-scss-module__R9aHHq__quiz",
  "quiz-section": "DynamicTariff-module-scss-module__R9aHHq__quiz-section",
  "summary": "DynamicTariff-module-scss-module__R9aHHq__summary",
  "summary-section": "DynamicTariff-module-scss-module__R9aHHq__summary-section",
});
